import { templateLocationTypes } from '@qdabra/forms-shared';
import {
    LOCATION_TYPE_DOCUMENT,
    LOCATION_TYPE_LOCAL_FILE,
} from '../Qd/constants/formLocationTypes';
import {
    URL_PARAMETER_DOCUMENT,
    URL_PARAMETER_FV_DOCUMENT_PATH,
    URL_PARAMETER_LIBRARY,
    URL_PARAMETER_TEMPLATE,
    URL_PARAMETER_TEMPLATE_NAME,
} from '../Qd/constants/url.parameter.names';
import { either } from 'ramda';

/*

TemplateLocationType is 'template' | 'library' | 'templateName'
DocumentLocationType is 'document' | 'localfile'

FormLocation is {
    templateLocationType: TemplateLocationType
    templateLocation: String
    documentLocationType: DocumentLocationType
    documentLocation: String
}

*/

const {
    LOCATION_TYPE_XSN,
    LOCATION_TYPE_TEMPLATE_NAME,
    LOCATION_TYPE_LIBRARY,
} = templateLocationTypes;

export const FORM_LOCATION_PROP_TEMPLATE_LOCATION_TYPE = 'templateLocationType';
export const FORM_LOCATION_PROP_TEMPLATE_LOCATION = 'templateLocation';
export const FORM_LOCATION_PROP_DOCUMENT_LOCATION_TYPE = 'documentLocationType';
export const FORM_LOCATION_PROP_DOCUMENT_LOCATION = 'documentLocation';

const getTemplateLocationType = (templateName, library, template) => {
    if (templateName) {
        return LOCATION_TYPE_TEMPLATE_NAME;
    }
    if (library) {
        return LOCATION_TYPE_LIBRARY;
    }
    if (template) {
        return LOCATION_TYPE_XSN;
    }

    return null;
};

const getDocumentLocationType = (document, localFile) => {
    if (document) {
        return LOCATION_TYPE_DOCUMENT;
    }
    if (localFile) {
        return LOCATION_TYPE_LOCAL_FILE;
    }

    return null;
};

// Returns true if the location is for a document file (i.e. not just a template)
export const isDocumentLocation = ({
    [FORM_LOCATION_PROP_DOCUMENT_LOCATION_TYPE]: documentLocationType,
    [FORM_LOCATION_PROP_DOCUMENT_LOCATION]: documentLocation,
}) => !!(documentLocationType && documentLocation);

export const isTemplateLocation = ({
    [FORM_LOCATION_PROP_TEMPLATE_LOCATION_TYPE]: templateLocationType,
    [FORM_LOCATION_PROP_TEMPLATE_LOCATION]: templateLocation,
}) => !!(templateLocationType && templateLocation);

export const isLocationSpecified = either(
    isDocumentLocation,
    isTemplateLocation,
);

// (String -> String) -> FormLocation
export const determineFormLocation = (getParameter) => {
    const [templateName, library, document, template, localFile] = [
        URL_PARAMETER_TEMPLATE_NAME,
        URL_PARAMETER_LIBRARY,
        URL_PARAMETER_DOCUMENT,
        URL_PARAMETER_TEMPLATE,
        URL_PARAMETER_FV_DOCUMENT_PATH,
    ].map(getParameter);

    const templateLocation = template || library || templateName;
    const documentLocation = document || localFile;

    return {
        [FORM_LOCATION_PROP_TEMPLATE_LOCATION_TYPE]: getTemplateLocationType(
            templateName,
            library,
            template,
        ),
        [FORM_LOCATION_PROP_TEMPLATE_LOCATION]: templateLocation,
        [FORM_LOCATION_PROP_DOCUMENT_LOCATION_TYPE]: getDocumentLocationType(
            document,
            localFile,
        ),
        [FORM_LOCATION_PROP_DOCUMENT_LOCATION]: documentLocation,
    };
};
